<div class='discussionContainer'>
  @for (item of this.discussions; track item) {
    <div class='discussionItem'>
      <div class='discussAvatar' style='text-align:center;'>
        <img src='https://eu.ui-avatars.com/api/?name={{ item.user.firstName }}}+{{ item.user.lastName }}&size=100'><br />
        <strong>{{ item.user.firstName }} {{ item.user.lastName }}</strong>
      </div>
      <div class='discussMessage'>
        <strong>{{ this.getAgo(item.createdAt) }}</strong><br />
        {{ item.message  }}
      </div>
      <hr />
    </div>
  }
  <div class='newDiscussionPost'>
    <h4 class='header'>Add a comment</h4>
    <textarea class='form-control' [(ngModel)]="this.newDiscussion.message"></textarea>
    <br />
    <br />
    <button class='btn btn-primary' type='button' (click)='post()'>Post</button><br /><br />
  </div>
</div>
